export default __webpack_public_path__ + "static/media/extensions.144f2a69.md";